import { cva as a } from "../../modules/index.es4.js";
const e = a("animate-spin -ml-1 mr-3", {
  variants: {
    size: {
      xs: "h-4 w-4",
      sm: "h-6 w-6",
      md: "h-8 w-8",
      lg: "h-12 w-12"
    },
    appearance: {
      default: "text-gray",
      primary: "text-primary",
      secondary: "text-secondary",
      tertiary: "text-tertiary",
      success: "text-success",
      danger: "text-danger",
      warning: "text-warning",
      info: "text-info"
    }
  },
  defaultVariants: {
    size: "md",
    appearance: "primary"
  }
});
export {
  e as spinnerVariants
};
//# sourceMappingURL=Spinner.styles.es.js.map
